export const customerTableColors = {
  backgroundColorHead: 'rgba(0, 0, 0, 0.2)',
  backgroundHoverRow: '#baddff',
  backgroundSelectedRow: '#98cbfd',
  backgroundActiveRow: '#a1f0ff',
};
